import React from 'react'

const About = () => {
    return (
        <div style={{marginTop:80}}>
         <img src="https://i.imgur.com/gK8b3rk.png" alt="aboutus"/>   
        </div>
    )
}

export  {About}
